import React, { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Form, Modal } from "react-bootstrap";

export const ACTIVITY_SCORE_TYPES = [
  { value: "activity_photo_approval", label: "Envio de foto" },
  { value: "activity_photo_competition_winner", label: "Competição de fotos" },
  { value: "activity_participant_voting_winner", label: "Votação" },
];

export const validateActivityScoreRule = (form = {}, lockedType = null) => {
  const type = lockedType || form.type;
  const description = String(form.description || "").trim();
  const value = form.value === "" ? Number.NaN : Number(form.value);
  if (!ACTIVITY_SCORE_TYPES.some((option) => option.value === type)) return "Atividade inválida.";
  if (!description || description.length > 250 || !Number.isInteger(value) || value < 0 || value > 1000000) {
    return "Informe uma descrição de até 250 caracteres e um valor inteiro entre 0 e 1.000.000.";
  }
  return null;
};
const initialForm = (type) => ({ type: type || ACTIVITY_SCORE_TYPES[0].value, description: "", value: 0 });

const ActivityScoreRuleModal = ({ show, onHide, eventId, lockedType = null, onCreated }) => {
  const [form, setForm] = useState(initialForm(lockedType));
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setForm(initialForm(lockedType));
      setError("");
    }
  }, [show, lockedType]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationError = validateActivityScoreRule(form, lockedType);
    if (validationError) {
      setError(validationError);
      return;
    }
    const description = String(form.description).trim();
    const value = Number(form.value);
    setSubmitting(true);
    setError("");
    try {
      const response = await axios.post(`/api/event/plataformaEventos/scores/${eventId}/activity`, {
        type: lockedType || form.type,
        description,
        value,
      });
      await onCreated?.(response.data.score, response.data.scores || []);
      onHide();
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Não foi possível criar a regra de pontuação.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={submitting ? undefined : onHide} centered backdrop="static" style={{ zIndex: 1070 }} backdropClassName="nested-modal-backdrop-lv2">
      <div>
        <Modal.Header closeButton={!submitting}><Modal.Title>Criar nova regra de pontuação</Modal.Title></Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger" className="p-2">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Atividade</Form.Label>
            <Form.Select value={lockedType || form.type} disabled={Boolean(lockedType)} onChange={(event) => setForm((current) => ({ ...current, type: event.target.value }))}>
              {ACTIVITY_SCORE_TYPES.map((type) => <option key={type.value} value={type.value}>{type.label}</option>)}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control required maxLength={250} value={form.description} onChange={(event) => setForm((current) => ({ ...current, description: event.target.value }))} />
            <Form.Text className="text-muted">{form.description.length}/250</Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>Pontos</Form.Label>
            <Form.Control required type="number" min="0" max="1000000" step="1" value={form.value} onChange={(event) => setForm((current) => ({ ...current, value: event.target.value }))} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="secondary" disabled={submitting} onClick={onHide}>Cancelar</Button>
          <Button type="button" disabled={submitting} onClick={handleSubmit}>{submitting ? "Criando..." : "Criar regra"}</Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default ActivityScoreRuleModal;
